/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp.  2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 */
define([
], function () {
	'use strict';


	let featureProfileOptDebug = false;
	try {
		featureProfileOptDebug = !!window.localStorage.getItem('performance.log.featureLoaderOpt');
	} catch ( err ) {
		// swallow localstorage errors...
	}



	class FeatureProfileHelper {
		constructor(profileList) {
			this.currProfileList = profileList  || ['core'];
			this.currProfileList = JSON.parse( JSON.stringify(this.currProfileList)  );
			if( featureProfileOptDebug ){
				console.log( 'FeatureProfileHelper current profile ', this.currProfileList);
			}
			this._parkedFeatures = []; //keep track of features that get parked - features not loaded because they didn't match current profile
		}

		filterAndTrackFeaturesForProfile( options ){
			let collectionItems = this.filterFeaturesForProfile( options );
			this.addToParkedFeatures(options.excludedList);

			//DEBUG
			if( featureProfileOptDebug ){
				console.log('loadFeaturesFromArray, loading', collectionItems.length, collectionItems,  'from ', options.collectionItemsIn.length, 'excluded', options.excludedList, 'current profile', this.currProfileList, ' input list ', options.collectionItemsIn );
			}
			// const profiles = ['core', 'consume', 'authoring'];
			// this._debugLogfeatureSummary(options.collectionItemsIn, profiles, 'loading ');
			//DEBUG

			return collectionItems;
		}

		// _debugLogfeatureSummary(collectionItems, profiles, msg) {
		// 	//for debugging only
		// 	let featuresSummary = '';
		// 	const undefProfile = 'undefined';
		//
		// 	let bkdown = {};
		//
		// 	collectionItems.forEach( (item) => {
		// 		const feature =  item.name;
		// 		if( !item.profile ) {
		// 			bkdown[undefProfile] = bkdown[undefProfile] || {};
		// 			bkdown[undefProfile].features = bkdown[undefProfile].features || [];
		// 			bkdown[undefProfile].features.push(feature);
		// 		}
		// 	});
		//
		// 	for( let i = 0; i< profiles.length; i++ ){
		// 		const profile = profiles[i];
		// 		collectionItems.forEach( (item) => {
		// 			const feature =  item.name;
		// 			if(item.profile && item.profile.includes(profile)) {
		// 				bkdown[profile] = bkdown[profile] || {};
		// 				bkdown[profile].features = bkdown[profile].features || [];
		// 				bkdown[profile].features.push(feature);
		// 			}
		// 		});
		//
		// 		let profileSummary = 'profile ' +  profile;
		// 		if( bkdown[profile] && bkdown[profile].features ) {
		// 			profileSummary += ' features ' + bkdown[profile].features.length;
		// 		}
		// 		featuresSummary += profileSummary + '\n';
		// 		if( bkdown[profile] && bkdown[profile].features) {
		// 			console.log( 'features for ', profile, ' : ', bkdown[profile].features);
		// 		}
		// 	}
		//
		// 	bkdown[undefProfile] = bkdown[undefProfile] || {};
		// 	bkdown[undefProfile].features = bkdown[undefProfile].features || [];
		// 	console.log('undefined profiles', bkdown[undefProfile].features);
		// 	console.log( msg, featuresSummary);
		// 	return featuresSummary;
		// }

		filterFeaturesForProfile( options ){
			let { collectionItemsIn, profileIn, strict, excludedList, logger } = options;

			strict = strict || false;

			let profile = profileIn ? [...profileIn]: this.currProfileList;
			let collectionItems = [];
			collectionItemsIn.forEach( (feature) => {
				if( this._doesProfileMatch( feature, profile )  ) {
					collectionItems.push(feature);
				} else if( !feature.profiles && !strict ) {
					logger && logger.warn('Feature missing profile: ' + feature.id || feature.name );
					collectionItems.push(feature); //for now
				} else {
					if(excludedList)  {
						excludedList.push(feature);
					}
				}
			});
			return collectionItems;
		}

		_doesProfileMatch( feature, currProfileList ) {
			let featureProfile = feature && feature.profiles || [];
			for( let i=0; i<featureProfile.length; i++ ) {
				let profile = featureProfile[i];
				if( currProfileList.includes(profile) ) {
					return true;
				}
			}
			return false;
		}


		addToParkedFeatures( excludedList ) {
			for(let j=0; j< excludedList.length; j++) {
				const excludedItem = excludedList[j];
				if( !this._parkedFeatures.includes( excludedItem ) ) {
					this._parkedFeatures.push( excludedItem );
				}
			}
		}

		getParkedFeatureList() {
			return this._parkedFeatures;
		}

		setParkedFeatureList(newList) {
			this._parkedFeatures = newList;
		}


		getCurrentProfile() {
			return this.currProfileList;
		}

		addToCurrentProfile( profiles = [] ) {
			let added = false;
			for( let i=0; i < profiles.length; i++ ){
				const profile = profiles[i];
				if( !this.currProfileList.includes(profile) ) {
					this.currProfileList.push(profile);
					added = true;
				}
			}

			return added;
		}

		removeFromCurrentProfile( profiles = [] ) {
			let currentList = this.currProfileList;

			for( let i=0; i < profiles.length; i++ ){
				const profileToRemove = profiles[i];
				currentList = currentList.filter( (profile) => {
					if( profile !== profileToRemove ) {
						return profile;
					}
				} );
			}

			this.currProfileList = currentList;
		}

	}

	return FeatureProfileHelper;
});
